import { Trascodifica } from './trascodifica';

export class EfficienzaEnergetica {
	id: number;
	annoCostruzione: number;
	stato: Trascodifica;
	idStato: number;
	climatizzatore: boolean;
	tipologiaRiscaldamento: Trascodifica;
	idTipologiaRiscaldamento: number;
	classeEnergetica: Trascodifica;
	idClasseEnergetica: number;
	inAttessa: boolean;
	esente: boolean;
	consumo: number;
	annoCostruzioneAntecedente: boolean;

	constructor() {
		this.stato = new Trascodifica();
		this.tipologiaRiscaldamento = new Trascodifica();
		this.classeEnergetica = new Trascodifica();
		this.climatizzatore = false;
		this.idStato = null;
		this.idTipologiaRiscaldamento = null;
		this.idClasseEnergetica = null;
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/efficienza-energetica.ts